import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { ModalBody, ModalTitle } from '@vds/modals';
import tile from '../../assets/img/accessories/media/images-accessories/VVC.svg';
import { apiUrl } from '../../constants/apiUrl';
import { updateSCTags } from './../../service/dtmTag';
import { getVZDLInit } from '../../service/vzdl';
import { store } from './../../index';
import { connect } from 'react-redux';

class PopupToApplyVisaCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondPopup: false
    };
  }
  togglePopupWindow = (value) => {
    this.props.closeFirstPopup();
    this.setState({
      secondPopup: !this.state.secondPopup,
    });
    let visitIdVal = store && store.getState() && store.getState().appVTP && store.getState().appVTP.visitId ? store.getState().appVTP.visitId : "";
    if(value==="apply"){
      updateSCTags("apply")
      setTimeout(() => {
        getVZDLInit(visitIdVal, "keep_previous_page_name", '', '', ' You’re leaving Verizon to Synchrony Bank’s side', 'Accessories', '', '')
      }, 1000);
    }
    else if (value==="close"){
     updateSCTags("close sign")
    }
  };
   handleRedirect = () => {
    this.setState({
      secondPopup: false,
    });
    setTimeout(()=>{ 
      window.location.href = apiUrl().applyVvcUrl
    },1000)
    updateSCTags("Continue") 
  };

  render() {
    let vvcRewardsUrl = apiUrl().vvcRewardsUrl;  
 return (
      <React.Fragment>
        <Modal focusTrapped={true} overlayId="redeem_popup" onClose={()=>this.props.closeFirstPopup("close1")} open={this.props.showFirstPopup} center>
          <div  className="apply-visacard-popup tiny-padding-all-large scroller " aria-live="polite">
            <ModalTitle>
              <h1  className="redeem_popup_title apply-vvc-content-font">
                Apply for Verizon Visa Card®
              </h1>
            </ModalTitle>
            <ModalBody>
          
              <div className="vvc-popup">
                <div className="vvc-popup-content">
                  <img src={tile} alt="VVC"/>
                </div>
                <div className="vvc-para apply-vvc-content-font">
                  <p>
                    <strong>Application required</strong>. Subject to credit approval. To apply, must be a Verizon Wireless Account Owner or Account
                    Manager on an account with up to 12 phone lines max (depending on plan) or Fios Account Owner with at least one active Fios
                    service.
                  </p>
                  <p>The Verizon Visa Signature® Card is issued by Synchrony Bank pursuant to a license from Visa USA Inc.</p>

                  <p>
                    <strong> Rewards:</strong> Purchases subject to credit approval. Verizon Dollars will be forfeited for Rewards Program inactivity.
                    See the Verizon Visa® Credit Card Rewards Program Terms & Conditions in application for details and restrictions.{' '}
                  <br/>
                    <a href={vvcRewardsUrl}>verizon.com/support/verizon-visa-card-rewards-legal/</a>
                    </p>
                  <p>
                    <strong> NO ANNUAL FEE</strong>: For New Accounts: Variable Purchase APRs are 23.99%, 26.99% or 30.99% for the Verizon Visa
                    Signature Credit Card. APRs are accurate as of 8/1/23 and will vary with the market based on Prime Rate (as defined in your credit
                    card agreement). Minimum Interest Charge is $2.
                  </p>
                </div>
              </div>
            </ModalBody>
                 
              <div 
              className="butttonDiv left margin-top-xlarge tiny-margin-bottom-medium ">
                <button
                  className="button text-xlarge tiny-padding-right-medium tiny-padding-left-medium redeem_popup_modal_nooutline"
                  tabIndex="2"
                  onClick={()=>this.togglePopupWindow("apply")}
                >
                  Apply
                </button>
              </div>
            
          </div>
        </Modal>
        {this.state.secondPopup ? (
                  <div>
                    <React.Fragment>
                      <Modal focusTrapped={true} overlayId="redeem_popup" onClose={()=>this.togglePopupWindow("close")} open={true} center>
                        <div className="apply-visacard-popup second-popup tiny-padding-all-large" aria-live="polite">
                          <ModalTitle>
                            <h1 className="redeem_popup_title apply-vvc-content-font">
                              You’re leaving Verizon to Synchrony Bank’s site
                            </h1>
                          </ModalTitle>
                          <ModalBody>
                            <div>
                              <div>
                                <p className='apply-vvc-content-font'>
                                  By clicking “Continue”, you’ll be automatically redirected to Synchrony Bank, the issuer of the Verizon Visa Card,
                                  to see if you prequalify.
                                </p>
                              </div>
                            </div>
                          </ModalBody>
                          <div className="btn-continue left margin-top-xlarge tiny-margin-bottom-medium">
                            <button 
                              className="button text-xlarge tiny-padding-right-medium tiny-padding-left-medium redeem_popup_modal_nooutline"
                              tabIndex="2"
                              onClick={this.handleRedirect}
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      </Modal>
                    </React.Fragment>
                  </div>
                ) : null}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    appState: state.appVTP,
    categoriesState: state.categoriesVTP,
    productstate: state.productsVTP,
    cartProduct: state.cartProductDataVTP,
  };
};
export default  connect(mapStateToProps)(PopupToApplyVisaCard);